import './sub-navbar.scss';
import { sanitizeString as sStr } from '../../../assets/js/text-renderer';

const getSubnav = (title, anchors) => `
<div class="subnav">
  <span class="subnav__title d-none d-lg-block">
    ${title}
  </span>
  <nav 
    class="subnav__tabs container" 
    role="tablist"
  >
    ${anchors.map((a) => `
      <a 
        id="${a.id}"
        class="nav-link ${a.active ? 'active' : ''} ${a.mobileLabel ? 'd-none d-lg-flex' : ''}" 
        href="${a.href}"
        data-target="${a.dataTarget}"
      >${a.label}</a>
      ${ a.mobileLabel ? `
        <a 
          class="nav-link ${a.active ? 'active' : ''} d-flex d-lg-none"
          href="${a.href}"
          data-target="${a.dataTarget}"
        >${a.mobileLabel}</a>
      ` : '' }
    `).join('')}
  </nav>
</div>`;

/**
 * SubNavBar Web Component
 * 
 * Attributes:
 * 
 * - title: Establece el título principal de la barra de navegación.
 * 
 * - <a> - tab-label: Establece el labels que se mostrará en el link de navegación.
 * 
 * - <a> - mobile-label: Establece el label que se mostrará en dispositivos móviles.
 * 
 * - <a> - href: Establece la url de destino del link de navegación.
 * 
 * - <a> - active: Establece si el link de navegación tiene estilo activo.
 */
class SubNavBar extends HTMLElement {
  connectedCallback() {
    if (
      DEVELOPMENT || (
      window['__PRERENDER_INJECTED'] && 
      window['__PRERENDER_INJECTED'].render_text)
    ) {
      this.render();
    };

    this.toggleActiveTab();
    this.handleScrollNavVisibility();
  }

  render() {
    const title = sStr(this.getAttribute('title'));
    const anchors = this.getAnchors();
    this.innerHTML = getSubnav(title, anchors);
  }

  getAnchors() {
    const anchorTags = Array.from(this.querySelectorAll(':scope > a'));
    return anchorTags.map((anchor) => ({      
      id: sStr(anchor.getAttribute('id')) || '',
      label: sStr(anchor.getAttribute('label')) || '',
      mobileLabel: sStr(anchor.getAttribute('mobile-label')) || undefined,
      href: sStr(anchor.getAttribute('href')) || '#',
      dataTarget: sStr(anchor.getAttribute('data-target')) || '',
      active: anchor.hasAttribute('active') ? true : false,
    }));
  };

  //* EVENT HANDLERS
  toggleActiveTab() {
    const tabs = this.querySelectorAll('.subnav__tabs > a');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
      });
    });
  }

  handleScrollNavVisibility() {
    const navContainer = document.getElementById('navbar-container');
    const navBar = document.getElementById('navbar');
    let lastScrollY = window.scrollY;

    const onScroll = () => {
      if(navBar && navBar.classList.contains('open'))
        return;

      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        navContainer && navContainer.classList.add('hidden');
      } else {
        navContainer && navContainer.classList.remove('hidden');
      }
      lastScrollY = currentScrollY;
    }

    window.addEventListener('scroll', onScroll);
  }
}

customElements.define('custom-sub-navbar', SubNavBar);